import { jsx as _jsx } from "react/jsx-runtime";
import { alpha } from "@mui/material/styles";
import { ElementChip } from "./base/ElementChip";
import { ValueIcon } from "./valueIcons/ValueIcon";
import { findValueIcon, MEDICAL_FALLBACK_ICON, MEDICAL_ICONS } from "./valueIcons/valueIconMaps";
var COLOR = "#7B5FA4";
var ICON_SX = { fontSize: 18, color: COLOR };
/** The value's own icon, else the medical icon. */
export function MedicalIcon(_a) {
    var _b;
    var value = _a.value;
    var spec = (_b = findValueIcon(MEDICAL_ICONS, value)) !== null && _b !== void 0 ? _b : MEDICAL_FALLBACK_ICON;
    return _jsx(ValueIcon, { glyph: spec.glyph, off: spec.off, sx: ICON_SX });
}
export function MedicalElement(_a) {
    var label = _a.label, value = _a.value, _b = _a.active, active = _b === void 0 ? false : _b, onClick = _a.onClick, onDelete = _a.onDelete;
    if (!label)
        return null;
    return (_jsx(ElementChip, { text: label, startIcon: _jsx(MedicalIcon, { value: value }), borderColor: alpha(COLOR, 0.28), active: active, onClick: onClick, onDelete: onDelete }));
}
